export default "__VITE_ASSET__Dv61i92R__"